/**
 * Created by zl on 2024年02月05日14:09:32.
 * @desc: 自定义对象父级路由
 * @children Object 动态追加
 * {
 *   path: ''|'add'|'edit',
 *   name: 'entity:['view'|'add'|'edit']',
 *   meta: { roles: role, title: '标题' },
 *   component: () => import('@/views/custom/['custom'|'custom-update/custom-update'].vue')
 * }
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');

const CUSTOM = {
  path: '/custom',
  name: 'custom',
  component: DEFAULT_LAYOUT,
  children: [],
  meta: {
    title: '自定义对象',
    requiresAuth: true
    // roles: 'custom',
  }
};

export default CUSTOM;
